<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    :root {
        --main-color: #409eff;
        --main-color2: #ecf5ff;
    }

    html, body {
        margin: 0;
        padding: 0;
    }

    @media screen and (max-width: 380px) {
        .el-message {
            min-width: 0!important;
            width: 92%!important;
        }
    }

    a {
        color: #606266;
        text-decoration: none;
    }
</style>
